module.exports = __webpack_public_path__ + "img/pic2.6566e3f9.png";